module.exports = __webpack_public_path__ + "static/media/02_insideyourblood.64695c2b.jpg";